import { useCallback } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import TransactionErrorHandler from 'src/utils/TransactionErrorHandler/TransactionErrorHandler';

export const useTxErrorHandler = () => {
	const walletAdapter = useVelocityStore((s) => s.wallet?.current?.adapter);

	const handleTxError = useCallback(
		(error: any, toastId: string, errorTitle?: string) => {
			if (!walletAdapter) return;

			TransactionErrorHandler.handleError({
				error,
				toastId,
				wallet: walletAdapter,
				errorTitle,
			});
		},
		[walletAdapter]
	);

	return handleTxError;
};
